import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import { CoreContainer, Notification } from "../common/style";
import {
  getOrderCutlist,
  getSignedCutlistURL,
  getSignedPricingExportURL,
} from "../project/service";
import { Option } from "../product/style";
import LoadingSpinner from "../project/LoadingSpinner";
import { AppContext } from "../context";
import { useParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";

const tableStyle = {
  width: "100%",
  fontSize: "12px",
};
const theadStyle = {
  textAlign: "left",
  verticalAlign: "middle",
};
const tbodyStyle = {
  textAlign: "left",
};
const copyStyle = {
  textAlign: "right",
};

const OrderCutlist = () => {
  const { organizationData } = useContext(AppContext);
  const { projectInfo: project } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [copiedContent, setCopiedContent] = useState("");
  const tableRef = useRef(null);
  const [cuttingLengthVisible, setCuttingLengthVisible] = useState(false);
  const [copied, setCopied] = useState(false);
  const [detailedCutlistView, setDetailedCutlistView] = useState(false);
  const [invalidPanelCount, setInvalidPanelCount] = useState(0);
  const [isAdmin] = useOutletContext();

  const params = useParams();
  const projectId = params.projectId;
  const orderId = params.orderId;

  const showOrderCutlistSummary = () => {
    setIsLoading(true);
    getOrderCutlist({
      projectId,
      orderId,
    })
      .then((response) => {
        project.cutlist = response.items;
        setInvalidPanelCount(response.invalid_panel_count);
        setDetailedCutlistView(
          project.cutlist[0] &&
            project.cutlist[0].hasOwnProperty("project_assembly_label")
        );
      })
      .catch(({ error }) => {
        setNotification({ message: error, type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    showOrderCutlistSummary();
  }, []);

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const copyTableData = () => {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(tableRef.current);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("copy");
    selection.removeAllRanges();
    setCopiedContent(window.getSelection().toString());
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  const downloadCutlist = (cutlistFormat) => {
    getSignedCutlistURL({ projectId, orderId, cutlistFormat }).then((signed) => {
      window.open(signed.url, "_blank", "noreferrer");
    });
  };

  const downloadPricingExport = () => {
    getSignedPricingExportURL({ projectId, orderId }).then((signed) => {
      window.open(signed.url, "_blank", "noreferrer");
    });
  };

  return (
    <>
      {isAdmin && (
        <div style={{ height: "75vh", overflow: "scroll" }}>
          {notification.type && (
            <Notification
              color={notification.type === "error" ? "danger" : "success"}
              isOpen={isNotificationVisible}
              toggle={onDismissNotification}
            >
              {notification.message}
            </Notification>
          )}
          {isLoading ? (
            <CoreContainer>
              <LoadingSpinner />
            </CoreContainer>
          ) : (
            <>
              {project && project.cutlist && (
                <div style={copyStyle}>
                  <div className="d-flex justify-content-between align-items-center my-3">
                    <div className="btn-group" style={{ height: "40px" }}>
                      <Option
                        onClick={() => setCuttingLengthVisible(false)}
                        className={`default-option ${
                          !cuttingLengthVisible && "selected-option"
                        }`}
                      >
                        Finish Length
                      </Option>
                      <Option
                        onClick={() => setCuttingLengthVisible(true)}
                        className={`default-option ${
                          cuttingLengthVisible && "selected-option"
                        }`}
                      >
                        Cutting Length
                      </Option>
                    </div>
                    {isAdmin && (
                      <div className="d-flex column-gap-1">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            caret
                            className="justify-content-center align-items-center rounded-1 bg-success px-5 border-0 text-white fw-bold"
                            style={{ width: "150px", height: "32px" }}
                          >
                            Download
                          </DropdownToggle>

                          <DropdownMenu
                            style={{
                              backgroundColor: "#f7f2f2",
                              fontSize: "12px",
                            }}
                          >
                            <DropdownItem
                              key="copy"
                              href="#"
                              onClick={copyTableData}
                            >
                              <span>Copy</span>
                            </DropdownItem>
                            <DropdownItem
                              key="download_format_1"
                              href="#"
                              onClick={() => downloadCutlist("plank")}
                            >
                              <span>Plank Format (CSV)</span>
                            </DropdownItem>
                            <DropdownItem
                              key="download_format_2"
                              href="#"
                              onClick={() => downloadCutlist("smartspace")}
                            >
                              <span>SmartSpace Format (CSV)</span>
                            </DropdownItem>
                            <DropdownItem
                              key="pricing_export"
                              href="#"
                              onClick={downloadPricingExport}
                            >
                              <span>Pricing (CSV)</span>
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    )}
                  </div>
                  <div className="w-100 overflow-scroll">
                    {invalidPanelCount > 0 && (
                      <div className="bg-danger text-white text-center p-3 mb-2">
                        {invalidPanelCount}{" "}
                        {invalidPanelCount > 1 ? "panels" : "panel"} invalid
                      </div>
                    )}
                    <Table
                      className="cutlist_table"
                      innerRef={tableRef}
                      style={tableStyle}
                      striped
                      bordered
                      hover
                    >
                      <thead style={theadStyle}>
                        <tr className="text-center">
                          {!detailedCutlistView && <th>S.No</th>}
                          {detailedCutlistView && <th>Room</th>}
                          {detailedCutlistView && <th>Group</th>}
                          {detailedCutlistView && <th>Product</th>}
                          <th>Name</th>
                          {isAdmin && (
                            <>
                              <th>Rate</th>
                              <th>Wastage (%)</th>
                            </>
                          )}
                          {detailedCutlistView && <th>Assembly Label</th>}
                          {detailedCutlistView && <th>Factory Label</th>}
                          <th>Material</th>
                          <th>Thickness</th>
                          <th>Length 1</th>
                          <th>Length 2</th>
                          <th>Side 1</th>
                          <th>Side 2</th>
                          <th>Edge</th>
                          <th>Remarks</th>
                          <th>Module Remarks</th>
                          {!detailedCutlistView && <th>Quantity</th>}
                        </tr>
                      </thead>
                      <tbody className="align-middle" style={tbodyStyle}>
                        {project.cutlist &&
                          project.cutlist.map((cutlistLineItem, index) => {
                            return (
                              <tr
                                key={index}
                                className={`text-center ${
                                  cutlistLineItem.invalid && "invalid"
                                }`}
                              >
                                {!detailedCutlistView && <td>{index + 1}</td>}
                                {detailedCutlistView && (
                                  <td>{cutlistLineItem.room_name}</td>
                                )}
                                {detailedCutlistView && (
                                  <td>{cutlistLineItem.group_name}</td>
                                )}
                                {detailedCutlistView && (
                                  <td>{cutlistLineItem.product_name}</td>
                                )}
                                <td>{cutlistLineItem.name}</td>
                                {isAdmin ? (
                                  cutlistLineItem.price_and_wastage ? (
                                    <>
                                      <td>
                                        {cutlistLineItem.price_and_wastage.rate}
                                      </td>
                                      <td>
                                        {
                                          cutlistLineItem.price_and_wastage
                                            .wastage
                                        }
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td>Price Outdated</td>
                                      <td>Price Outdated</td>
                                    </>
                                  )
                                ) : null}
                                {detailedCutlistView && (
                                  <td>
                                    {cutlistLineItem.project_assembly_label}
                                  </td>
                                )}
                                {detailedCutlistView && (
                                  <td>{cutlistLineItem.factory_label}</td>
                                )}
                                <td>{cutlistLineItem.material_name}</td>
                                <td>{cutlistLineItem.thickness + " mm"}</td>
                                <td>
                                  {!cuttingLengthVisible
                                    ? cutlistLineItem.length_1
                                    : cutlistLineItem.cutting_length_1}
                                </td>
                                <td>
                                  {!cuttingLengthVisible
                                    ? cutlistLineItem.length_2
                                    : cutlistLineItem.cutting_length_2}
                                </td>
                                <td>{cutlistLineItem.side_1_color || "Raw"}</td>
                                <td>{cutlistLineItem.side_2_color || "Raw"}</td>
                                <td>{cutlistLineItem.edges}</td>
                                <td>
                                  {cutlistLineItem.grooves}
                                  {cutlistLineItem.has_minifix &&
                                  cutlistLineItem.grooves
                                    ? " / "
                                    : ""}
                                  {cutlistLineItem.has_minifix ? "Minifix" : ""}{" "}
                                </td>
                                {!detailedCutlistView && (
                                  <td>{cutlistLineItem.quantity}</td>
                                )}
                                <td>{cutlistLineItem.module_remarks}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default OrderCutlist;
